import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import elementUI from '@/elementUI'
import '@/style/element/element-variables.scss'
import '@/assets/font/font.css'
import utils from '@/components/utils'
import SvgIcon from 'vue-svgicon'
import filters from '@/vue-plugins/vue-filter'
import '@/utils/updater'
import 'uno.css'

Vue.use(elementUI)
Vue.use(utils)
Vue.use(filters)

Vue.prototype.$EventBus = new Vue()
Vue.config.productionTip = false
Vue.use(SvgIcon, {
  tagName: 'svgicon'
})
new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')

Vue.directive('loadImage', {
  // 当被绑定的元素插入到 DOM 中时……
  inserted: function (el, binding) {
    const src = el.src
    const newImg = new Image()
    newImg.src = src
    newImg.onload = function (v) {
      binding?.value?.(v)
    }
  }
})
